// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card[data-v-632eb321] {\n    width: 340px !important;\n}\n.password-reset-form[data-v-632eb321] {\n    margin-top: 1em !important;\n    margin-bottom: 1em !important;\n}\n", ""]);
// Exports
module.exports = exports;
